export function controlContentVisible() {
  const DOM = {
    options: document.querySelectorAll("[data-action=select-content]"),
    contents: document.querySelectorAll("[data-contenttarget]")
  }

  if (DOM.options && DOM.options[0]) {
    DOM.options.forEach(element => {
      element.addEventListener("click", function() {
        DOM.options.forEach(element => {
          element.classList.remove("text-white") // Disable
          element.classList.add("bg-transparent", "text-primary", "border-primary") // Disable
        })

        // Enable
        this.classList.remove("bg-transparent", "text-primary", "border-primary")
        this.classList.add("bg-green-600", "text-white")

        DOM.contents.forEach(element => {
          if (element.dataset.contenttarget == this.dataset.content) {
            element.classList.remove("hidden")
          } else {
            element.classList.add("hidden")
          }
        })
      })
    })
  }
}

if (document.querySelectorAll("[data-action=select-content]").length && document.querySelectorAll("[data-contenttarget]").length) {
  controlContentVisible();
}
